import { useId } from 'react';

export function AccountField({
  label,
  value,
  onChange,
  type = 'text',
  autoComplete,
  maxLength,
  minLength,
  required = true,
  hint,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: 'text' | 'email' | 'password';
  autoComplete: string;
  maxLength?: number;
  minLength?: number;
  required?: boolean;
  hint?: string;
}) {
  const id = useId();
  const hintId = hint ? `${id}-hint` : undefined;

  return (
    <label htmlFor={id} className="block text-xs font-medium text-muted">
      {label}
      <input
        id={id}
        type={type}
        required={required}
        autoComplete={autoComplete}
        value={value}
        maxLength={maxLength}
        minLength={required ? minLength : undefined}
        aria-describedby={hintId}
        onChange={(event) => onChange(event.target.value)}
        className="mt-1 w-full rounded-xl border border-line bg-shell px-3 py-2 text-sm text-ink outline-none focus:border-brand"
      />
      {hint && (
        <span id={hintId} className="mt-1 block font-normal text-muted">
          {hint}
        </span>
      )}
    </label>
  );
}
